/**
 * settlement
 *
 * @author
 * @date
 */
import { t, RSP_ITEM_TYPE } from '@/domain/base'

export const SettlementReq = [
  {
    label: t('settlement.billMonth'),
    prop: 'billMonth',
    type: 'date',
    format: 'YYYY-MM',
    valueFormat: 'YYYY-MM',
  }
]

export const SettlementColumns = [
  {
    prop: "monthId",
    label: t('settlement.billMonth'),
    align: "left",
  },
  {
    prop: "settlementAmt",
    label: t('settlement.amount'),
    align: "right",
    type: RSP_ITEM_TYPE.AMOUNT,
    depend: 'settlementCcy',
  },
  {
    prop: "tpvAmt",
    label: 'TPV',
    align: "right",
    type: RSP_ITEM_TYPE.AMOUNT,
  },
  {
    prop: "settlementStatus",
    label: t('settlement.settlementStatus'),
    align: "center",
    type: RSP_ITEM_TYPE.MAPPING_TAG,
    category: "settlementStatus",
  },
  {
    prop: "settlementTime",
    label: t('settlement.settledTime'),
    align: "center",
    type: RSP_ITEM_TYPE.DATE,
    category: "YYYY-MM-DD HH:mm:ss"
  },
  {
    prop: "lastTime",
    label: t('settlement.lastUpdateTime'),
    align: "center",
    type: RSP_ITEM_TYPE.DATE,
  },
  {
    prop: "option",
    slot: "option",
    label: t('client.table.text_6'),
    align: "center",
  },
]

export const SalesSettlementColumns = [
  {
    prop: "monthId",
    label: t("settlement.billMonth"),
    align: "left",
    width: 170,
  },
  {
    prop: "inviteCode",
    label: t("salesSettlement.table.text_2"),
    width: 170,
  },
  {
    prop: "inviteCodeRemark",
    label: t("salesSettlement.table.text_3"),
    align: "left",
  },
  {
    prop: "settlementAmt",
    label: t("salesSettlement.table.text_4"),
    align: "right",
    type: RSP_ITEM_TYPE.AMOUNT,
    depend: 'settlementCcy',
  },
  {
    prop: "tpvAmt",
    label: t("salesSettlement.table.text_5"),
    align: "right",
    type: RSP_ITEM_TYPE.AMOUNT,
  },
  {
    prop: "settlementTime",
    label: t("salesSettlement.table.text_6"),
    align: "center",
    type: RSP_ITEM_TYPE.DATE,
    category: "YYYY-MM-DD HH:mm:ss"
  },
  {
    prop: "lastTime",
    label: t("salesSettlement.table.text_7"),
    align: "center",
    type: RSP_ITEM_TYPE.DATE,
    category: "YYYY-MM-DD HH:mm:ss"
  }
]
